import { getIcon as getAdd } from './add';
import { getIcon as getArrowBack } from './arrow_back';
import { getIcon as getBankruptcy } from './bankruptcy';
import { getIcon as getChevronDown } from './chevron_down';
import { getIcon as getCirCleIconOutlined } from './circle_icon_outlined';
import { getIcon as getClipboardExclamationOutlined } from './clipboard_exclamation_outlined';
import { getIcon as getClose } from './close';
import { getIcon as getDeleteOutlined } from './delete_outlined';
import { getIcon as getDownload } from './download';
import { getIcon as getEditOutlined } from './edit_outlined';
import { getIcon as getFileSearchOutlined } from './file_search_outlined';
import { getIcon as getFileDolarOutlined } from './file_dolar_outlined';
import { getIcon as getFilterOutlined } from './filter_outlined';
import { getIcon as getGaugeOutlined } from './gauge_outlined';
import { getIcon as getHelpOutlined } from './help_outlined';
import { getIcon as getIdCardOutlined } from './id_card_outlined';
import { getIcon as getNoDolarSign } from './no_dolar_sign';
import { getIcon as getNotificationOutlined } from './notification_outlined';
import { getIcon as getPartners } from './partners';
import { getIcon as getScaleBalance } from './scale_balance';
import { getIcon as getSearch } from './search';
import { getIcon as getStar } from './star';
import { getIcon as getStarOutlined } from './star_outlined';

const icons = [
  'add',
  'arrow_back',
  'bankruptcy',
  'chevron_down',
  'circle_icon_outlined',
  'close',
  'clipboard_exclamation_outlined',
  'delete_outlined',
  'download',
  'edit_outlined',
  'file_dolar_outlined',
  'file_search_outlined',
  'filter_outlined',
  'gauge_outlined',
  'help_outlined',
  'id_card_outlined',
  'no_dolar_sign',
  'notification_outlined',
  'partners',
  'scale_balance',
  'search',
  'star',
  'star_outlined',
] as const;

export type IconName = (typeof icons)[number];

function iconByMap(name: IconName, size: number, color: string) {
  const iconMap: Record<IconName, string> = {
    add: getAdd(size, color),
    arrow_back: getArrowBack(size, color),
    bankruptcy: getBankruptcy(size, color),
    chevron_down: getChevronDown(size, color),
    circle_icon_outlined: getCirCleIconOutlined(size, color),
    close: getClose(size, color),
    clipboard_exclamation_outlined: getClipboardExclamationOutlined(size, color),
    delete_outlined: getDeleteOutlined(size, color),
    download: getDownload(size, color),
    edit_outlined: getEditOutlined(size, color),
    file_dolar_outlined: getFileDolarOutlined(size, color),
    file_search_outlined: getFileSearchOutlined(size, color),
    filter_outlined: getFilterOutlined(size, color),
    gauge_outlined: getGaugeOutlined(size, color),
    help_outlined: getHelpOutlined(size, color),
    id_card_outlined: getIdCardOutlined(size, color),
    no_dolar_sign: getNoDolarSign(size, color),
    notification_outlined: getNotificationOutlined(size, color),
    partners: getPartners(size, color),
    scale_balance: getScaleBalance(size, color),
    search: getSearch(size, color),
    star: getStar(size, color),
    star_outlined: getStarOutlined(size, color),
  };

  return iconMap[name];
}

export function getIcon(name: IconName, size: number, color: string): string {
  return iconByMap(name, size, color);
}
